(function () {
  angular.module('leanlaw').directive("llAccountFilter", MatterFilterDirective).controller('AccountFilterController', AccountFilterController);
  function MatterFilterDirective() {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        ngDisabled: '=',
        filterSingleAccount: '='
      },
      template: require('./views/accountFilter.html'),
      controller: 'AccountFilterController',
      controllerAs: 'vm',
      link: function (scope, element, attrs, ngModel) {
        scope.updateModel = function (account) {
          ngModel.$setViewValue(angular.copy(account));
        };
        ngModel.$viewChangeListeners.push(function () {
          scope.$eval(attrs.ngChange);
        });
      }
    };
  }
  AccountFilterController.$inject = ['$scope', '$q', 'userService'];
  function AccountFilterController($scope, $q, userService) {
    var vm = this;
    vm.options = {};
    vm.account = {
      loading: true
    };
    vm.me = null;
    activate();

    /////////////////

    function activate() {
      $q.all([userService.me(), userService.list()]).spread(function (me, accounts) {
        vm.me = me;
        vm.options.accounts = accounts;
        vm.account = me;
      });
      $scope.$watch('vm.account', function (account) {
        if (account.loading) return;
        $scope.updateModel(account);
      }, true);
    }
  }
})();